module.exports = __webpack_public_path__ + "static/media/NotoSansKR-Bold.b59ac7cf.ttf";